import { render, staticRenderFns } from "./UserStat.vue?vue&type=template&id=000fba70"
import script from "./UserStat.vue?vue&type=script&lang=js"
export * from "./UserStat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports